module.exports = __webpack_public_path__ + "static/img/patho-pus-high-CVutrbLR.e68d6f76.png";